import { FC } from "react"

import {
    setEulaAccepted,
    setInformedAgreement,
    setOfferAccepted,
    setPersonalDataAccepted,
} from "modules/Booking/FormPage/common"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { ErrorsAcception } from "modules/Booking/FormPage/components/FormAcceptation/components/ErrorsAcception"
import { Tooltip } from "components"
import { INDIVIDUAL_OFFER, INFORMED_AGREEMENT, OFFER_LINK } from "utils/env-management"
import { Psychologist } from "utils/interfaces"
import { UserAccount } from "utils/UserAccount"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

interface Props {
    psy: Psychologist
}

export const FormAcceptation: FC<Props> = ({ psy }) => {
    const [
        {
            form: {
                offerAccepted,
                personalDataAccepted,
                informedAgreement,
                eulaAccepted,
                showErrors,
            },
        },
        { dispatch },
    ] = useFormPageContext()
    const [{ userAccount: clientUserAccount }] = useClientContext()
    const isB2b = clientUserAccount.is_b2b

    return (
        <div className="booking-form__checkboxes">
            <div className="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    className="custom-control-input"
                    id="check_offer"
                    name="offerAccepted"
                    checked={offerAccepted}
                    onChange={() => dispatch(setOfferAccepted(!offerAccepted))}
                />
                <label
                    className="custom-control-label booking-form__checkbox"
                    htmlFor="check_offer"
                >
                    <div className="booking-form__checkbox__text">
                        Соглашаюсь{" "}
                        <a
                            href={`${OFFER_LINK}?${psy.legal_info}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="personal-info__link"
                        >
                            с офертой психолога
                        </a>{" "}
                        и&nbsp;подтверждаю, что мне есть 18&nbsp;или{" "}
                        <div className="is-inline-block">
                            <Tooltip
                                placement="top"
                                overlay={
                                    <div className="booking-form__tooltip">
                                        Если вам нет&nbsp;18, обязательно принесите на&nbsp;первую
                                        сессию{" "}
                                        <a
                                            href="https://psyalter.helpdeskeddy.com/ru/knowledge_base/article/3/category/3/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="contact-request-popup__personal-data-link"
                                        >
                                            письменное согласие
                                        </a>{" "}
                                        от&nbsp;одного из&nbsp;родителей. Либо приходите
                                        на&nbsp;сессию с&nbsp;родителем или законным представителем.
                                    </div>
                                }
                            >
                                <span className="personal-info__link">согласие родителей</span>
                            </Tooltip>
                        </div>
                    </div>
                </label>
            </div>
            <div className="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    className="custom-control-input"
                    id="check_personal_data"
                    name="personal_data_accepted"
                    checked={personalDataAccepted}
                    onChange={() => dispatch(setPersonalDataAccepted(!personalDataAccepted))}
                />
                <label
                    className="custom-control-label booking-form__checkbox"
                    htmlFor="check_personal_data"
                >
                    <div className="booking-form__checkbox__text">
                        Соглашаюсь на обработку{" "}
                        <a
                            href={UserAccount.makePersonalAgreementUrl(psy.legal_info)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="personal-info__link"
                        >
                            персональных данных
                        </a>
                    </div>
                </label>
            </div>
            {isB2b && (
                <div className="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="informed_agreement"
                        name="informedAgreement"
                        checked={informedAgreement}
                        onChange={() => dispatch(setInformedAgreement(!informedAgreement))}
                    />
                    <label
                        className="custom-control-label booking-form__checkbox"
                        htmlFor="informed_agreement"
                    >
                        <div className="booking-form__checkbox__text">
                            Ознакомлен с&nbsp;
                            <a
                                href={`${INFORMED_AGREEMENT}?name=${psy.last_name} ${psy.first_name} ${psy.middle_name}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="personal-info__link"
                            >
                                информированным согласием
                            </a>
                        </div>
                    </label>
                </div>
            )}
            <div className="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    className="custom-control-input"
                    id="check_age"
                    name="ageAccepted"
                    checked={eulaAccepted}
                    onChange={() => dispatch(setEulaAccepted(!eulaAccepted))}
                />
                <label className="custom-control-label booking-form__checkbox" htmlFor="check_age">
                    <div className="booking-form__checkbox__text">
                        Принимаю{" "}
                        <a
                            href={INDIVIDUAL_OFFER}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="personal-info__link"
                        >
                            оферту сервиса
                        </a>
                    </div>
                </label>
            </div>
            {showErrors && (
                <ErrorsAcception
                    offerAccepted={offerAccepted}
                    eulaAccepted={eulaAccepted}
                    personalDataAccepted={personalDataAccepted}
                    informedAgreement={(informedAgreement && isB2b) || !isB2b}
                />
            )}
        </div>
    )
}
